/**
 * usePilot hook.
 */
import { PilotType, PilotProps as Props } from '@shared/types/props/pilot';
import { modalSelector } from '@shared/store/slices/modal.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useMemo } from 'react';

/**
 * Hook to get the pilot component data.
 */
export default function usePilotSelector(parentProps: Props) {
  const { current: modal } = useAppSelector(modalSelector);
  return useMemo(() => {
    const { asset, channel, display, hint, type } = parentProps;
    return {
      props: {
        container: {
          display,
        },
        footer: {
          ...(type === PilotType.VOD
            ? { asset }
            : { asset: channel?.currentEvent ?? undefined, channel, hint }),
          type,
        },
        header: {
          type,
        },
        logo: {
          channel,
          display: !modal,
        },
      },
    };
  }, [parentProps, modal]);
}
